import { render } from "./DeliveryDate.vue?vue&type=template&id=65a5f9b4"
import script from "./DeliveryDate.vue?vue&type=script&lang=js"
export * from "./DeliveryDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__